// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".column-header[data-v-34824590]{height:33px;border-bottom:1px solid #dadada;border-top:1px solid #dadada}", ""]);
